import janusApi from "../../janus-api";
import history from "../../utils/history";

const ROOM_LOGIN = "kbport/room/LOGIN";
const ROOM_LOGIN_REQUEST = "kbport/room/LOGIN_REQUEST";
const ROOM_LOGOUT = "kbport/room/LOGOUT";

const login = (username, room, pin, secret, adminLogin = undefined) => {
  return function (dispatch) {
    const roomId = parseInt(room);

    dispatch(loginRequest({ roomId, username, pin, secret, adminLogin }));

    janusApi
      .enterRoom({ id: roomId }, username, pin)
      .then(() => {
        dispatch(loginSuccess({ roomId, username, secret, adminLogin }));
      })
      .catch((error) => {
        dispatch(loginFailure(error));
      });
  };
};

const loginRequest = ({ roomId, username, secret, pin, adminLogin }) => ({
  type: ROOM_LOGIN_REQUEST,
  payload: { roomId, username, pin, secret, adminLogin },
});

const loginSuccess = ({ roomId, username, secret, adminLogin }) => ({
  type: ROOM_LOGIN,
});

const loginFailure = (error) => ({
  type: ROOM_LOGIN,
  payload: { error: error },
});

const logout = () => {
  return function (dispatch) {
    janusApi.leaveRoom();

    dispatch({ type: ROOM_LOGOUT });

    history.push("/");
  };
};

const actionCreators = {
  login,
  logout,
  loginFailure,
};

const actionTypes = {
  ROOM_LOGIN,
  ROOM_LOGIN_REQUEST,
  ROOM_LOGOUT,
};

export const initialState = { loggedIn: false, loggingIn: false };

const reducer = function (state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case ROOM_LOGIN_REQUEST: {
      return { ...payload, loggingIn: true };
    }
    case ROOM_LOGIN: {
      if (payload !== undefined && payload.error) {
        return {
          ...state,
          loggingIn: false,
          loggedIn: false,
          error: payload.error,
        };
      } else {
        return {
          ...state,
          loggingIn: false,
          loggedIn: true,
          isAdmin: state.secret ? true : false,
        };
      }
    }
    case ROOM_LOGOUT: {
      return { ...state, loggedIn: false };
    }
    default:
      return state;
  }
};

export { actionCreators, actionTypes };

export default reducer;
